import OneNetworkConfig from '@/onenetwork/core/onenetwork.config.ts'
import PrivateRouter from '@/onenetwork/layouts/PrivateRouter.vue'
import PushCampaignList from '@/modules/push-campaign/views/PushCampaignList.vue'

const baseRoute = OneNetworkConfig.baseRoutePath
const pushCampaignRouter = [
  {
    path: `${baseRoute}/push-campaign/list`,
    name: 'push-campaign-list',
    meta: {
      component: PushCampaignList
    },
    component: PrivateRouter,
  },
]
export default pushCampaignRouter
